import styled from 'styled-components'

import { COLOURS, BREAKPOINTS } from 'resources/constants'

export const LayoutContainer = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    'nav-menu'
    'main'
    'footer';

  @media (min-width: ${BREAKPOINTS.md}) {
    grid-template-columns: auto 1fr;
    grid-template-rows: 1fr auto;
    grid-template-areas:
      'nav-menu main'
      'footer footer';
  }
`

export const MainContainer = styled.main`
  grid-area: main;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  background-color: ${COLOURS.neutralWhite};
  z-index: 1;
`

export const NavMenuContainer = styled.nav`
  grid-area: nav-menu;
  z-index: 3;
  display: flex;
`

export const FooterContainer = styled.footer`
  min-height: 80px;
  max-height: 100px;
  grid-area: footer;
  z-index: 2;
`
